import React, { Fragment, useCallback, useEffect } from 'react'
import { connect } from 'react-redux'
import SectionItem from '@components/Layout/SectionItem/SectionItem'
import './MessageForm.scss'
import { LuxSelect, LuxRichInputText, LuxMultiSelect, LuxButton } from '@lux/wardrobe-lib'
import { useIntl } from 'react-intl'
import SectionItemContainer from '@/app/components/Layout/SectionItemContainer/SectionItemContainer'
import AddAttachment from '@components/UI/AddAttachment/AddAttachment'
import { ProjectsService } from '@/app/services/ProjectsService'
import { NEW_ACTIVITY_EXECUTION_NAMESPACE } from '@/app/redux/reducers/activity-execution'

const reasonOptions = [
    { value: 'ask-info', label: 'modals.new.activity.execution.messaging.reason.ask.info' },
    {
        value: 'material-missing',
        label: 'modals.new.activity.execution.messaging.reason.material.missing',
    },
    {
        value: 'material-damaged',
        label: 'modals.new.activity.execution.messaging.reason.material.damaged',
    },
    { value: 'do-not-apply', label: 'modals.new.activity.execution.messaging.reason.do.not.apply' },
    {
        value: 'store-message',
        label: 'modals.new.activity.execution.messaging.reason.store.message',
    },
    {
        value: 'system-problem',
        label: 'modals.new.activity.execution.messaging.reason.system.problem',
    },
    { value: 'other', label: 'modals.new.activity.execution.messaging.reason.other' },
]

const MessageForm = (props) => {
    const componentClass = 'smart-new-activity-execution-message-form'
    const {
        form,
        stores,
        title,
        onMessageSave,
        onReduce,
        onCreateMessage,
        isMessageCreateLoading,
    } = props
    const intl = useIntl()

    useEffect(() => {
        onMessageSave({ reason: reasonOptions[0].value })
    }, [])

    const storeItemTemplate = useCallback((store) => store ? `${store.storeId} | ${store.storeName}` : '', []);

    const onSave = () => {
        onCreateMessage()
    }
    const onUpload = (files) => {
        onMessageSave({
            attachmentList: [
                ...form.attachmentList,
                ...files.map((file: any) => ({
                    file: file.file,
                    url: file.url,
                    id: file.id,
                })),
            ],
        })
    }
    const onRemoveAttachment = (file) => {
        let newList = [...form.attachmentList]
        const fileIndex = newList.findIndex((i) => i.file.name === file.name)
        newList.splice(fileIndex, 1)
        onMessageSave({
            attachmentList: [...newList],
        })
    }

    const isDisabled = () => {
        return !form.message || !form.reason || !form.stores.length
    }

    const ctaTemplate = (
        <Fragment>
            <LuxButton
                onClick={onSave}
                text={intl.formatMessage({
                    id: 'modals.new.activity.execution.messaging.save',
                    defaultMessage: 'Save',
                })}
                disabled={isDisabled()}
                variant="outlined"
                loading={isMessageCreateLoading}
                style={{ marginBottom: '16px' }}
            />
        </Fragment>
    )

    return (
        <SectionItemContainer ctaTemplate={ctaTemplate}>
            <SectionItem>
                <div className={`${componentClass}__item-title`} onClick={() => onReduce()}>
                    <span className={`${componentClass}__item-title-reduce`}>-</span>
                    <span className="link-mini">{title}</span>
                </div>
            </SectionItem>
            <SectionItem>
                <div className={`${componentClass}__select-container`}>
                    <LuxSelect
                        label={intl.formatMessage({
                            id: 'modals.new.activity.execution.messaging.reason',
                            defaultMessage: 'Messaging Reason',
                        })}
                        mandatory
                        value={form.reason}
                        onChangeCallback={(value) => onMessageSave({ reason: value })}
                        placeholder={intl.formatMessage({
                            id: 'modals.new.activity.execution.messaging.reason',
                            defaultMessage: 'Messaging Reason',
                        })}
                        options={reasonOptions.map((opt) => ({
                            ...opt,
                            label: intl.formatMessage({
                                id: opt.label,
                                defaultMessage: opt.label.split('.').pop(),
                            }),
                        }))}
                        additionalProps={{
                            appendTo: 'self',
                        }}
                    />
                    <LuxMultiSelect
                        value={form.stores}
                        onChangeCallback={(value) => onMessageSave({ stores: value })}
                        placeholder={intl.formatMessage({
                            id: 'modals.new.activity.execution.messaging.stores',
                            defaultMessage: 'Selected Stores',
                        })}
                        options={stores || []}
                        additionalProps={{
                            appendTo: 'self',
                            itemTemplate: storeItemTemplate,
                            selectedItemTemplate: storeItemTemplate,
                            filterBy: 'storeName,storeId',
                        }}
                        filterable
                    />
                </div>
            </SectionItem>
            <SectionItem>
                <LuxRichInputText
                    value={form.message}
                    onChangeCallback={(value) => onMessageSave({ message: value })}
                    label={intl.formatMessage({
                        id: 'modals.new.activity.execution.messaging.message',
                        defaultMessage: 'Information',
                    })}
                    placeholder={intl.formatMessage({
                        id: 'modals.new.activity.execution.messaging.message.placeholder',
                        defaultMessage: 'Type here',
                    })}
                    fileUploadUrl={ProjectsService.FROALA_UPLOAD_URL}
                />
            </SectionItem>
            <SectionItem>
                <AddAttachment
                    id={`message-${Math.random() * 100}`}
                    form={{ attachmentList: { value: form.attachmentList } }}
                    onUpload={(form) => onUpload(form)}
                    showRemoveIcon
                    showSplitFile={false}
                    onRemove={(file) => onRemoveAttachment(file)}
                    messageEndpoint="projectmessage"
                />
            </SectionItem>
        </SectionItemContainer>
    )
}

const mapStateToProps = (state: any) => ({
    isMessageCreateLoading: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].isMessageCreateLoading,
})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(MessageForm)
